import { render } from "./RecoveryPassword.vue?vue&type=template&id=335b595b&scoped=true&ts=true"
import script from "./RecoveryPassword.vue?vue&type=script&lang=ts"
export * from "./RecoveryPassword.vue?vue&type=script&lang=ts"

import "./RecoveryPassword.vue?vue&type=style&index=0&id=335b595b&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_apib/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-335b595b"]])

export default __exports__